export default "__VITE_ASSET__D5XbAUkH__"